import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const DeleteListingModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "DeleteListingModalContainer" */
      './DeleteListingModalContainer'
    ),
  loading: LoadingModal,
});
